export default __webpack_public_path__ + "static/planet1-5a5f693a3b76611d27e68cdb0b36262e.webp";